<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row class="mb-4">
        <b-col>
          <b-tabs>
            <b-tab title="Basis gegevens">
              <b-form @submit.prevent="submitForm" v-if="Customer">
                <b-row>
                  <b-col cols="12">
                    <h5>Basisgegevens</h5>
                    <hr>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="Naam">
                      <b-form-input type="text" required v-model="Customer.name" :disabled="!editable" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col cols="12">
                    <h5>Contactgegevens</h5>
                    <hr>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="E-mail">
                      <b-form-input type="email" required v-model="Customer.email" :disabled="!editable" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col cols="12">
                    <h5>Bedrijfsgegevens</h5>
                    <hr>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="Bedrijf" v-if="editable">
                      <company-select :multiple="false" :options="companies" v-model="Customer.company.id" :pre-populate="false" :disabled="!editable" />
                    </b-form-group>

                    <b-form-group label="Bedrijf" v-else>
                      <b-form-input type="text" required v-model="customerCompanyName" :disabled="true" />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                      <b-button @click.prevent="$router.push({ name: 'companies.view', params: { id: customerCompanyId } })" type="button" variant="primary">Bedrijf bekijken</b-button>
                  </b-col>

                </b-row>
                <b-row>
                  <b-col>
                    <hr />
                    <div v-if="editable">
                      <b-button type="submit" variant="success" class="pull-right" :disabled="loading">
                        <b-spinner v-show="loading" small type="grow" />
                        Opslaan
                      </b-button>
                      <b-button @click="editable = loading = false" class="pull-right mr-2" variant="warning">
                        Annuleren
                      </b-button>
                    </div>
                    <div v-else>
                      <b-button @click.prevent="editable = true" type="button" class="pull-right" variant="primary">
                        Bewerken
                      </b-button>
                      <b-button @click.prevent="sendInvitation" type="button" class="pull-right mr-1" variant="outline-success" :disabled="!hasSites || loading">
                        <b-spinner v-show="loading" small type="grow" />
                        Uitnodiging versturen
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </b-tab>

            <Requests :is-loading="loading" :requests="customerRequests" />
          </b-tabs>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { deleteItem, getData, storeData, updateData } from '../../api';
import CompanySelect from "../../components/CompanySelect";
import moment from 'moment';

import Requests from './tabs/Requests';

export default {
  name: 'customer',
  components: { CompanySelect, Requests },
  data() {
    return {
      loading: false,
      editable: false,
      errors: [],
      Customer: null,
      companies: null,
      requests: [],
    };
  },
  computed: {
    customerCompany() {
      if (!this.Customer || !this.companies) return null;

      const {company} = this.Customer;
      const companies = this.companies;

      let len = companies.length;
      let n = 0;
      let result = null;

      for (n; n < len; n++) {
        if (companies[n].id === company.id) {
          result = companies[n];
          break;
        }
      }

      return result;
    },
    customerCompanyId() {
      return this.customerCompany ? this.customerCompany.id : null;
    },
    customerCompanyName() {
      return this.customerCompany ? this.customerCompany.name : null;
    },
    customerRequests () {
      if (!this.Customer || !this.Customer.requests) return [];
      return this.Customer.requests.sort((a, b) => a.created_at > b.created_at ? -1 : a.created_at < b.created_at ? 1 : 0).map((item) => {
        return {
          id: item.id,
          site: item.site_id === 2 ? 'Check Sociaal' : item.site_id === 1 ? 'VerhuurSignaal' : '-',
          bedrijf: this.customerCompanyName,
          aantal: item.call_count,
          downloads: item.downloads,
          errors: item.failures,
          'Laatst bekende statuscode': item.status_code, 
          'Eerste keer uitgevoerd': this.formatDate(item.created_at),
          'Laatste update': this.formatDate(item.updated_at),
        };
      });
    },
    hasSites() {
      let result = this.Customer.company && this.Customer.company.sites && this.Customer.company.sites.length > 0;
      return result;
    }
  },
  methods: {
    async getCustomerData() {
      const { id } = this.$route.params;

      return await getData(`customers/${id}`).then(({ data }) => {
        this.Customer = data.data;
      });
    },
    async getCompaniesData() {
      return await getData('companies?per_page=9999').then(({ data }) => {
        this.companies = data.data.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      });
    },
    submitForm() {
      this.loading = true;

      const data = this.Customer;
      data.company_id = data.company.id;
      const { id } = this.$route.params;

      updateData(`customers/${id}`, data)
        .then(({ data }) => {
          this.loading = false;
          this.editable = false;
          this.Customer = data.data;

          this.$bvToast.toast('Klant is succesvol gewijzigd', {
            title: 'Succes',
            variant: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    sendInvitation() {
      this.loading = true;
      const { id } = this.$route.params;

      storeData(`customer/${id}/send-invitation`)
        .then(({ data }) => {
          this.$bvToast.toast('De uitnodiging is met succes verstuurd.', {
            title: 'Succes',
            variant: 'success',
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
        formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD MMMM YYYY, HH:mm');
    }
  },
  beforeMount() {
    this.getCompaniesData().then(() => {
      this.getCustomerData();
    });
  },
};

</script>
